module.exports = __webpack_public_path__ + "static/pool2-7f2f83b9c8f420c91497f02a8244d7e5.jpg";